export default __webpack_public_path__ + "static/media/ferry-train.e7a492f9.svg";